import { MessageVideoIcon } from './MessageVideoIcon';

/**
 * author: Google
 * id 7AEB07C3-0EFC-4D74-BB5B-2EB1288DC27D
 * name message-video
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-video.svg
 * tags
 * - Video / Movie 
 */
export const VoiceChatIcon = MessageVideoIcon;
export default VoiceChatIcon